const swiper = new Swiper(".mv__scrollImgArea", {
	loop: true, // ループ有効
	speed: 40000, // ループの時間
	allowTouchMove: false, // スワイプ無効
	autoplay: {
		delay: 0, // 途切れなくループ
	},
});

jQuery(function ($) {
	$(document).on('click', '.catBtn', function () {
		// e.preventDefault() 不要
		console.log('clicked');
		var cat = $(this).data('cat');

		$('.catBtn').removeClass('is-active');
		$(this).addClass('is-active');

		if (cat === 'all') {
			$('.newsList__item').show();
		} else {
			$('.newsList__item').hide().filter('.' + cat).show();
		}
	});
});


//formタグにクラス追加
document.querySelector(".wpcf7-form").classList.add("hide_error_message");

//送信または確認ボタンをクリックしたとき
document.querySelectorAll(".wpcf7-confirm, .wpcf7-submit").forEach(function (elm) {
	elm.addEventListener("click", function () {
		document.querySelector(".wpcf7-form").classList.remove("hide_error_message");
	});
});
